module.exports = __webpack_public_path__ + "img/user.6b164146.svg";